export class EnrichedError extends Error {
  override name: 'EnrichedError' = 'EnrichedError';

  constructor(msg?: string, public extra?: Record<string, any>) {
    super(msg);
  }
}
